import "./Modal.css";
import React, { useEffect, useRef } from "react";
import { IoClose } from "react-icons/io5";

const Modal = ({ isOpen, onClose, children, title }) => {
  const openRef = useRef(isOpen);

  useEffect(() => {
    openRef.current = isOpen
  }, [isOpen])

  

  useEffect(() => {
    window.addEventListener("click", () => {
      if (openRef.current) onClose();
    });
    return () =>
      window.removeEventListener("click", () => {
        if (openRef.current) onClose();
      });
  }, []);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>
          <IoClose />
        </button>
        <div className="modal-title">{title}</div>
        {children}
      </div>
    </div>
  );
};

export default Modal;
